import { InjectionToken } from '@angular/core';
import { Library, Loader } from '@googlemaps/js-api-loader';

export const GOOGLE_MAPS_LOADER: InjectionToken<Loader> =
  new InjectionToken<Loader>('GoogleMapsLoader');

export const GOOGLE_MAPS_LIBRARY: InjectionToken<Library> =
  new InjectionToken<Library>('GoogleMapsLibrary');
